import React from "react";
import { Modal as MaterialModal } from "@material-ui/core";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  place-items: center;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  top: calc(50% - 600px / 2);
  height: 600px;
  width: 900px;
  margin: auto;
`;

export interface IModalProps extends React.ComponentPropsWithRef<"div"> {
  open: boolean;
  onClose?: () => void;
}

function Modal({ open, children, onClose, ...props }: IModalProps) {
  return (
    <MaterialModal open={open} onClose={onClose}>
      <Container {...props}>{children}</Container>
    </MaterialModal>
  );
}

export default Modal;
